import { NgModule, ErrorHandler, inject, provideAppInitializer } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import * as Sentry from '@sentry/angular'
import { Router } from '@angular/router'

import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'

import { SnackBarModule } from './shared/snack-bar/snack-bar.module'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'

import { S3urlResolverService } from './services/s3url-resolver.service'
import { SENTRY_CONFIG } from './configs/sentry.config'

export function init_app(S3URLResolverService: S3urlResolverService) {
  return () => S3URLResolverService.load()
}

//Sentry configuration service
Sentry.init({
  dsn: SENTRY_CONFIG?.DSN,
  tracePropagationTargets: SENTRY_CONFIG.ALLOW_ORIGIN,
  integrations: [
    Sentry.browserTracingIntegration({
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: SENTRY_CONFIG.TRACES_SAMPLE_RATE,
  replaysSessionSampleRate: SENTRY_CONFIG.REPLAY_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate: SENTRY_CONFIG.REPLAY_ON_ERROR_SAMPLE_RATE,
})

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule, AppRoutingModule, BrowserAnimationsModule, SnackBarModule], providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        { provide: Sentry.TraceService, deps: [Router] },
        provideAppInitializer(() => {
        inject(Sentry.TraceService)
        const initializerFn = init_app(inject(S3urlResolverService))
        return initializerFn();
      }),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
  constructor() {
    const path = window.location.href.split('#/')

    if (window.location.href.includes('#/action')) {
      window.location.href = `${path[0]}${path[1]}`
    }

    if (window.location.href.includes('#/signin')) {
      const path = window.location.href.split('#/')
      window.location.href = `${path[0]}${path[1]}`
    }
  }
}
